/**
 * nodash — native replacements for lodash utilities.
 * Import from "@/utils/nodash" instead of "lodash".
 */

export function camelCase(str) {
  return str
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, ch) => ch.toUpperCase())
    .replace(/^[A-Z]/, ch => ch.toLowerCase());
}

export function debounce(fn, wait) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function endsWith(str, target) {
  return String(str).endsWith(target);
}

export function first(arr) {
  return arr?.[0];
}

export function get(obj, path, defaultValue) {
  const keys = typeof path === "string" ? path.split(".") : [path];
  let result = obj;
  for (const key of keys) {
    result = result?.[key];
    if (result === undefined) return defaultValue;
  }
  return result;
}

export function isEmpty(value) {
  if (value == null) return true;
  if (Array.isArray(value) || typeof value === "string") return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return true;
}

export function isEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function isFunction(value) {
  return typeof value === "function";
}

export function isUndefined(value) {
  return value === undefined;
}

export function last(arr) {
  return arr?.[arr.length - 1];
}

export function round(num, precision = 0) {
  const factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
}

export function sortBy(arr, key) {
  const getter = typeof key === "function" ? key : item => item?.[key];
  return [...arr].sort((a, b) => {
    const va = getter(a);
    const vb = getter(b);
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  });
}

export function startCase(str) {
  return String(str)
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, ch => ch.toUpperCase());
}

export function startsWith(str, target) {
  return String(str).startsWith(target);
}

export function uniqBy(arr, key) {
  const getter = typeof key === "function" ? key : item => item?.[key];
  const seen = new Map();
  return arr.filter(item => {
    const k = getter(item);
    if (seen.has(k)) return false;
    seen.set(k, true);
    return true;
  });
}

export function uniqWith(arr, comparator) {
  return arr.filter(
    (item, index) => !arr.slice(0, index).some(other => comparator(item, other))
  );
}
